/*
  Aanvullers en lege-ladestart in de winkelmandlade (upgrade WA-01, WA-05).

  Met artikelen in de mand: aanbevelingen bij het eerste artikel, eerst
  intent=complementary (de koppelingen uit Search & Discovery die de PDP ook
  gebruikt) en anders gerelateerd. Producten die al in de mand liggen gaan
  eruit; er blijven er maximaal drie over. Leverbaarheid volgens de strenge
  regel zit al in sections/cart-recommendations.liquid.

  Lege mand: pas als de lade geopend wordt drie bestsellers ophalen
  (sections/aza-cart-start.liquid), zodat niet elke pagina die meelaadt.

  Ververst zichzelf als de inhoud van #AjaxCartForm wordt vervangen (na
  toevoegen, wijzigen of verwijderen); component-cart.js en
  component-quick-buy.js roepen generateRecommendations ook nog direct aan,
  daarom wordt er samengevoegd tot één ophaalronde.
*/
class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this._timer = null;
		this._ronde = 0;
		this.generateRecommendations();

		const form = document.getElementById('AjaxCartForm');
		if ( form ) {
			new MutationObserver(() => this.generateRecommendations()).observe(form, { childList: true });
		}
		const lade = document.getElementById('site-cart-sidebar');
		if ( lade ) {
			new MutationObserver(() => {
				const leeg = ! document.querySelector('#AjaxCartForm [data-js-cart-item]');
				if ( leeg && lade.classList.contains('sidebar--opened') ) this.generateRecommendations();
			}).observe(lade, { attributes: true, attributeFilter: ['class'] });
		}
	}

	generateRecommendations(){
		clearTimeout(this._timer);
		this._timer = setTimeout(() => this._laad(), 60);
	}

	async _haal(url, inMand){
		const text = await (await fetch(url)).text();
		const el = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-js-cart-recommendations-performed], [data-aza-lade-start]');
		if ( ! el ) return null;
		el.querySelectorAll('[data-product-id]').forEach(item => {
			if ( inMand.has(item.dataset.productId) ) item.remove();
		});
		[...el.querySelectorAll('[data-js-product-item]')].slice(3).forEach(item => item.remove());
		return el;
	}

	async _laad(){
		const ronde = ++this._ronde;
		const form = document.getElementById('AjaxCartForm');
		if ( ! form ) return;
		const artikelen = [...form.querySelectorAll('[data-js-cart-item]')];
		const inMand = new Set(artikelen.map(a => a.dataset.productId));

		try {
			let el = null;
			if ( artikelen.length ) {
				const basis = `${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${artikelen[0].dataset.productId}&limit=10`;
				el = await this._haal(`${basis}&intent=complementary`, inMand);
				if ( ! el || ! el.querySelector('[data-js-product-item]') ) el = await this._haal(basis, inMand);
				if ( el && ! el.querySelector('[data-js-product-item]') ) el = null;
			} else {
				if ( this.querySelector('[data-aza-lade-start]') ) return;
				// Aanvullers van een mand die nu leeg is, weghalen.
				this.innerHTML = '';
				const lade = document.getElementById('site-cart-sidebar');
				if ( ! lade || ! lade.classList.contains('sidebar--opened') ) return;
				const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
				el = await this._haal(`${root}?section_id=aza-cart-start`, inMand);
			}
			if ( ronde !== this._ronde ) return;
			this.innerHTML = el ? el.outerHTML : '';
		} catch (e) {
			if ( ronde === this._ronde ) this.innerHTML = '';
		}
	}
}
if ( ! customElements.get('cart-recommendations') ) {
	customElements.define('cart-recommendations', CartRecommendations);
}
